<template>
    <div class="tc-modal-bg"
         v-on:click.stop="storeUI.setIsShowModal(false)">
        <div class="tc-modal-window"
             @click.stop
             @pointerdown.stop>
            <div class="tc-modal-close-anchor">
                <div class="tc-modal-close"
                     @click.stop="storeUI.setIsShowModal(false)">
                    <SVGClose/>
                </div>
            </div>
            <component :is="modalComponent"></component>
        </div>
    </div>
</template>

<script>
import { useStoreUI } from '@/Store/storeUI';
import SVGClose from '@/UI/SVG/SVGClose.vue';
import ModalOrder from '@/UI/ModalComponents/ModalOrder.vue';
import ModalAR from '@/UI/ModalComponents/ModalAR.vue';
import ModalDeleteCaseAlert from '@/UI/ModalComponents/ModalDeleteCaseAlert.vue';
import ModalNewCaseTypeSelect from '@/UI/ModalComponents/ModalNewCaseTypeSelect.vue';
import ModalShare from '@/UI/ModalComponents/ModalShare.vue';
import ModalUnsavedCaseAlert from '@/UI/ModalComponents/ModalUnsavedCaseAlert.vue';
import ModalRename from '@/UI/ModalComponents/ModalRename.vue';


export default {
    name: 'TheModal',
    components: {
        ModalRename,
        ModalUnsavedCaseAlert,
        ModalShare,
        ModalNewCaseTypeSelect,
        ModalDeleteCaseAlert,
        ModalAR,
        ModalOrder,
        SVGClose,
    },
    setup() {
        const storeUI = useStoreUI();
        return {
            storeUI,
        };
    },
    data() {
        return {
            modalComponentRule: {
                'order': 'ModalOrder',
                'AR': 'ModalAR',
                'share': 'ModalShare',
                'unsavedCaseAlert': 'ModalUnsavedCaseAlert',
                'newCaseTypeSelect': 'ModalNewCaseTypeSelect',
                'deleteCaseAlert': 'ModalDeleteCaseAlert',
                'rename': 'ModalRename',
            },
        };
    },
    computed: {
        modalComponent() {
            return this.modalComponentRule[this.storeUI.activeModalName];
        },
    },
};
</script>

<style scoped lang="scss">
.tc-modal-bg {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    font-family: Montserrat, sans-serif;
    overflow: auto;
    position: absolute;
    z-index: 100;
    background-color: #00000035;
    padding: 30px 0;

    display: flex;
    justify-content: center;
    align-items: center;
}

.tc-modal-window {
    padding: 50px 40px 40px 40px;
    background-color: white;
    width: max-content;
    height: max-content;
    display: flex;
    flex-direction: column;
    min-width: 300px;
    min-height: 200px;
    box-sizing: border-box;
    position: relative;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

.tc-modal-close-anchor {
    position: absolute;
    display: flex;
    width: calc(100% - 80px);
    height: 0;
    justify-content: flex-end;
    align-items: flex-end;
}

.tc-modal-close {
    position: relative;
    width: 20px;
    height: 20px;
    display: flex;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    bottom: 17px;
    right: -26px;
    cursor: pointer;
    user-select: none;
    color: #333333;
    transition: 0.3s ease all;

}

.tc-modal-close:hover {
    color: #00458D;
}
</style>
